// eslint-disable-next-line @typescript-eslint/naming-convention
export enum Company_Title {
  'TRANSPORTATION' = 'Transportation Finance',
  'NFS' = 'Leasing Source',
}
